import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import servicesTypes from './types';
import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import servicesActions from './actions';
import services from './services';

function* getPoseRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getPoseList(action.payload),
			action
		);
		yield put(servicesActions.getPosesSuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(e, action, servicesActions.getPosesFailure);
	}
}
function* getPoseItemRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getPoseList(action.payload),
			action
		);
		yield put(servicesActions.getPoseItemSuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(e, action, servicesActions.getPoseItemFailure);
	}
}
function* getPackageRequest(action) {
	try {
		let response = yield sagaCallService(
			services.getPackageList,
			action,
			action.payload
		);
		yield put(servicesActions.getPackagesSuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(e, action, servicesActions.getPackagesFailure);
	}
}

function* setPosegeRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.addNewPos(action.payload),
			action
		);
		yield put(servicesActions.setPosesSuccess(response.data));
		if (action.payload?.noNeedRedirect != true)
			sessionStorage.setItem('redirect', '/services/cashback/list');
		yield (window.location = '/pwa/services/cashback/list');
	} catch (e) {
		yield sagaErrorDispatcher(e, action, servicesActions.setPosesFailure);
	}
}

function* updatePosRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.editPose(action.payload),
			action
		);
		yield put(servicesActions.updatePosSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, servicesActions.updatePosFailure);
	}
}

function* deactivePoseRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.deactivePos(action.payload),
			action
		);
		yield put(servicesActions.deactivePosesSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, servicesActions.deactivePosesFailure);
	}
}

function* editPoseRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.editPose(action.payload),
			action
		);
		yield put(servicesActions.editPosesSuccess(response.data));
		sessionStorage.setItem('redirect', '/services/cashback/list');
		yield (window.location = '/pwa/services/cashback/list');
	} catch (e) {
		yield sagaErrorDispatcher(e, action, servicesActions.editPosesFailure);
	}
}

function* getProductsRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getProductsList(action.payload),
			action
		);
		yield put(servicesActions.getProductsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, servicesActions.getProductsFailure);
	}
}

function* summaryRequest(action) {
	try {
		let response = yield sagaCallService(
			services.summaryBusiness,
			action,
			action.payload
		);
		yield put(servicesActions.summarySuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(e, action, servicesActions.summaryFailure);
	}
}

const servicesSaga = [
	takeEvery(servicesTypes.GET_POSES.REUQEST, getPoseRequest),
	takeEvery(servicesTypes.GET_POSES_ITEM.REUQEST, getPoseItemRequest),
	takeEvery(servicesTypes.GET_PACKAGES.REUQEST, getPackageRequest),
	takeLatest(servicesTypes.SET_POSES.REUQEST, setPosegeRequest),
	takeLatest(servicesTypes.DEACTIVE_POSES.REUQEST, deactivePoseRequest),
	takeLatest(servicesTypes.EDIT_POSE.REUQEST, editPoseRequest),
	takeLatest(servicesTypes.GET_PRODUCTS.REUQEST, getProductsRequest),
	takeEvery(servicesTypes.SUMMARY.REQUEST, summaryRequest),
	takeLatest(servicesTypes.UPDATE_POS.REUQEST, updatePosRequest),
];
export default servicesSaga;
